const restaurant = {
  restaurant: "餐厅", // translated
  restaurants: "餐厅", // translated
  category: "类别", // translated
  score: "分数", // translated
  priceQuartile: "价格四分位数", // translated
  scoreLowestFirst: "分数（最低的在前）", // translated
  scoreHighestFirst: "分数（最高的在前）", // translated
  priceLowestFirst: "价格（最低的优先）", // translated
  priceHighestFirst: "价格（最高的在前）", // translated
  allPrices: "所有价格", // translated
  reserve: "预订", // translated
  dining: "用餐", // translated
};


export default restaurant;
